import { experienceApiClient } from '@/config/httpClients';
import type {
  MobilePlanCardSchemaResponse,
  MobilePlanCardDataResponse,
} from './mobile.schema';
import { MobilePlanCardSchema } from './mobile.schema';

const getMobilePlanCard = async (): Promise<MobilePlanCardDataResponse[]> => {
  const response = await experienceApiClient
    .get<MobilePlanCardSchemaResponse>(
      `v1/product-catalog/mobile-offers?filter[brand]=EXETEL`
    )
    .json();

  if (!MobilePlanCardSchema.safeParse(response).success) {
    //TODO: Log error to Sentry
    console.log('API response validation error on getMobilePlanCard');
  }

  return response.data;
};

export { getMobilePlanCard };
